export const environment = {
  production: true,
  PATH_API: "https://www.liasys.net/api",
  PATH_CONSULTA_CEP: "https://viacep.com.br/ws/",
  LIMITE_REGISTROS_LISTA: 15,
};
